import { Box, Header } from '@rbilabs/universal-components';

import Link from 'components/link';
import { primitive } from 'styles/constants/primitives';

export const MenuNavigationTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  paddingTop: 4,
  paddingBottom: 2,
  fontFamily: Styles.fontFamily.body,
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: p.active ? Styles.color.tertiary : 'transparent',
      md: p.active ? Styles.color.black : 'transparent',
    },
  },

  borderBottomColor: p.active ? Styles.color.tertiary : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const MenuNavigationTabText = Header.withConfig<{ active?: boolean }>(p => ({
  color: p.active ? Styles.color.tertiary : Styles.color.tertiary,
  fontFamily: p.active ? Styles.fontFamily.base : Styles.fontFamily.body,
  marginTop: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
}));

export const MenuNavigationTabBorderBottom = Box.withConfig({
  position: 'absolute',
  bottom: 0,
  width: 'full',
  height: '$0.5',
  backgroundColor: primitive.$blackOpacity10,
});
